import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Button } from 'react-toolbox';
import { connect } from 'react-redux';
import SignatureBox from 'components/SignatureBox';
import S from 'modal.scss';
import { getPhaseErrors } from '../../../../../../../reducers';

class ContractorSignature extends Resetter(Validator(React.Component)) {
  state = {
    contractorSignature: this.props.contractorSignature || '',
    clearSignature: 0,
    errors: {},
  };

  static VALIDATIONS = {
    contractorSignature: true,
  }

  contractorSignatureRef = React.createRef();

  componentDidMount() {
    this.contractorSignatureRef.current.scrollIntoView(true);
  }

  handleSubmit = () => {
    if (!this.validate()) { return; }
    this.props.updateFormData({
      contractorSignature: this.state.contractorSignature,
      tab: 6,
    });
  }

  handlePrevious = () => {
    this.props.updateFormData({
      contractorSignature: this.state.contractorSignature,
      tab: 4,
    });
  }

  handleSignatureChange = (data) => {
    this.setState({ contractorSignature: data });
  }

  handleClear = () => {
    this.setState({
      contractorSignature: '',
      clearSignature: this.props.contractorSignature ? this.state.clearSignature : Date.now(),
    });
    this.props.updateFormData({ contractorSignature: '' });
  }

  render() {
    const { errors, clearSignature } = this.state;

    return (
      <div ref={this.contractorSignatureRef}>
        <h6>Part 5 - Contractor Signature</h6>
        <SignatureBox
          label="Sign Contractor's Name *"
          required
          value={this.props.contractorSignature}
          errors={errors.contractorSignature}
          clearTimestamp={clearSignature}
          onEnd={this.handleSignatureChange}
          onClear={this.handleClear}
        />
        <Button label="Complete" flat inverse ripple className={S.submit} onClick={this.handleSubmit} />
        <Button label="Previous" flat inverse ripple className={S.submit} onClick={this.handlePrevious} />
      </div>
    );
  }
}

ContractorSignature.propTypes = {
  errors: PropTypes.shape({
    contractorSignature: PropTypes.arrayOf(PropTypes.string),
  }),
};

export default connect(state => ({ errors: getPhaseErrors(state) }), {
})(ContractorSignature);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/cocSignature/contractor_signature.jsx